module.exports = __webpack_public_path__ + "flexslider-icon.9c9cb7a6055043933ba6.eot";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/components/flexslider/fonts/flexslider-icon.eot
// module id = ../../../../../src/assets/components/flexslider/fonts/flexslider-icon.eot
// module chunks = 2